<script>
  import { mapGetters, mapActions } from 'vuex'
  import * as Helper from '@/modules/helper/index'
  export default {
    data() {
      return {
        playPauseControl: null,
        IsLiked: false,
        IsFavorite: false,
        headerName: null,
        playerControl: null,
        playerReady: null
      }
    },
    computed: {
      ...mapGetters([
        'MainMenuLayout',
        'Stream',
        'AppConfig',
        'resource',
        'AudioPlayers'
      ]),      
      SubscriptionModuleId() {
        return parseInt(this.$f7route.params.Id)
      },
      Favorite() {
        this.IsFavorite = (Helper.IsValid(this.Stream)) ? Helper.CheckIsFavorite(this.Stream.Id, this.Stream.Id) : false
        return this.IsFavorite
      },
      IsLike() {
        if (Helper.IsValid(this.Stream)) {
          this.IsLiked = Helper.convertBoolean(this.Stream.IsLiked)
        }
        return this.IsLiked
      },
      Header() {
        this.headerName = (Helper.IsValid(this.Stream)) ? this.Stream.PageTitle : ''
        return this.headerName
      },
      StreamURL() {
        return !Helper.IsNullOrEmpty(this.Stream.StreamURL) ? this.Stream.StreamURL : ''
      },
      IsDevSim() {
        return Helper.IsDevSim()
      },
      randomNo() {
        return Helper.getRandomInt()
      },
      AudioPlayerInfo() {
        return this.AudioPlayers.find(player => player.id === 'audio-player-'+this.SubscriptionModuleId)
      },   
      TimeProgress() {
        return this.AudioPlayerInfo ? this.AudioPlayerInfo.timeProgress : '00:00'
      },
      EndTime() {
        // return this.AudioPlayerInfo ? this.AudioPlayerInfo.endTime : 'Live'
        return 'Live'
      },
      progressPercent() {
        return this.AudioPlayerInfo ? this.AudioPlayerInfo.timeProgressPercent : 0
      }
    },
    watch: {
      Stream: function(value, oldvalue) {
        if (oldvalue !== null && value.StreamURL !== oldvalue.StreamURL) {
           if (Helper.IsDevSim() && !this.playerControl.paused) {
             this.playerControl.pause()
             this.iconPlayPushUpdate('pause')
             this.playerControl.src = value.StreamURL
             this.playerControl.load()
           }
        }
      }
    },
    created() {
      this.initRadioModule(this.SubscriptionModuleId)
    },
    mounted() {
      if (this.$refs.radioPage) {
        this.$refs.radioPage.$on('page:reinit', (event, payload) => {
          this.initRadioModule(this.SubscriptionModuleId)
        })
        this.cretaePlayerInstance()
        if (this.playerControl.paused) {
          this.iconPlayPushUpdate('pause')
        } else {
          this.iconPlayPushUpdate('play')
        }
      }
    },
    beforeDestroy() {
      if (this.$refs.radioPage) {
        this.$refs.radioPage.$off('page:reinit', (event, payload) => {
          // this.initRadioModule(this.SubscriptionModuleId)
        })
      }
    },
    methods: {
      ...mapActions([
        'loadRadioStream',
        'loadRadioStreamLocalData',
        'addUpdateLike',
        'shareInformation',
        'addMyFavorite',
        'getUrlfromPls',
        'updateAudioPlayers',
        'updateAudioPlayerTimes'
      ]),
      async cretaePlayerInstance() {
        let _player = this.AudioPlayers.find(player => player.id === 'audio-player-'+this.SubscriptionModuleId)
        if(_player){
          this.playerControl = _player.player
        } else {
          let Player = document.createElement('audio')
          Player.id       = 'audio-player-'+this.SubscriptionModuleId
          Player.controls = 'controls'
          Player.class    = 'hide'
          document.body.appendChild(Player)
          _player = {
            player: Player,
            id: 'audio-player-'+this.SubscriptionModuleId,
            playerReady: false,
            timeProgress: '00:00',
            endTime: 'Live',
            timeProgressPercent: 0
          }
          this.playerControl = _player.player
          this.AudioPlayers.push(_player)
          this.updateAudioPlayers(this.AudioPlayers)
        }
      },
      async getformattedURL(url) {
        let URL
        if (!Helper.IsNullOrEmpty(url)) {
          URL = url
          if (URL.includes('.pls')) {
            let res = await this.getUrlfromPls(URL)
            let xhrDoc = res
            var pls = {}
            // split into lines
            pls.Entries = xhrDoc.split('\n')
            // Entry 0 is [playlist]
            // Entry 1 is NumberOfEntries=n
            pls.Count = pls.Entries[1].split('=')[1]
            // Entry 2,3,4 = File#=,Title#=,Length#=
            // repeat from 1 to NumberOfEntries
            pls.Items = []
            pls.curItem = 0
            pls.listOk = true
            let c = 2
            for (var i = 0; i < pls.Count; i++) {
              pls.Items.push({
                file: pls.Entries[i + c].split('=')[1],
                title: pls.Entries[i + c + 1].split('=')[1],
                length: pls.Entries[i + c + 2].split('=')[1]
              })
              c = c + 2
            }
            URL = pls.Items[0].file
            return URL
          } else {
            // console.log('URL', URL)
            // let jspayer = new jsmediatags.read(URL, {
            //     onSuccess: function(tag) {
            //       console.log(tag);
            //     },
            //     onError: function(error) {
            //       console.log(':(', error.type, error.info)
            //     }
            //   })
            return URL
          }
        } else {
          return ''
        }
      },
      initRadioModule(SubscriptionModuleId) {
        this.$showLoader()
        this.loadRadioStreamLocalData(SubscriptionModuleId)
        this.loadRadioStream(SubscriptionModuleId).then(() => {
          this.$hideLoader()
          this.$RegisterPageView({'SubscriptionModule_Id': SubscriptionModuleId, 'ContentGUID': this.Stream.Id, 'ViewType': 1})
        }).catch(err => {
          console.log('err', err)
          this.$hideLoader()
        })
      },
      onLikeClick() {
        let Like = {
          Reference_Id: this.Stream.Id,
          Liked: !Helper.convertBoolean(this.Stream.IsLiked),
          AppGUID: this.AppConfig.AppGUID,
          ContentType: 3,
          NotificationContent: {
            Title: this.Stream.PageTitle,
            ImageName: this.Stream.StreamCoverImage,
            Comment: '',
            Navigationurl: '/radio-view/' + this.SubscriptionModuleId
          }
        }
        this.addUpdateLike(Like).then(() => {
          this.$f7.notification.create({
            title: Helper.convertBoolean(this.Stream.IsLiked) ? this.resource.likeSuccesTitle : this.resource.disLikeSuccesTitle,
            subtitle: Helper.convertBoolean(this.Stream.IsLiked) ? this.resource.likeSuccesMessage : this.resource.disLikeSuccesMessage,
            cssClass: 'success-notification',
            closeOnClick: true,
            closeTimeout: 3000
          }).open()
        })
        // this.addUpdateLike(Like)
        this.IsLiked = Helper.convertBoolean(this.Stream.IsLiked)
      },
      onShareCLick() {
        let files = []
        if (Helper.IsValid(this.Stream.StreamCoverImage)) {
          files.push(this.AppConfig.Urls.ContentAssetsBaseUrl + this.Stream.StreamCoverImage)
        }
        let Options = {
          appConfig: this.AppConfig,
          moduleId: this.Stream.Module_Id,
          subscriptionModuleId: this.Stream.SubscriptionModule_Id,
          shareId: this.Stream.Id,
          path: Helper.CurrentlocationURL(),
          orderId: 0
        }
        this.shareInformation(Options)
      },
      onFavoriteClick() {
        let favData = {
          Reference_Id: this.Stream.Id,
          ReferenceParent_Id: this.Stream.Id
        }
        this.addMyFavorite(favData)
        this.IsFavorite = Helper.CheckIsFavorite(this.Stream.Id, this.Stream.Id)
      },
      forword() {
        this.playerControl.currentTime = this.playerControl.currentTime + 30
      },
      rewind() {
        this.playerControl.currentTime = this.playerControl.currentTime - 30
      },
      updateDuration() {
        try{
          let currentSeconds = (Math.floor(this.playerControl.currentTime % 60) < 10 ? '0' : '') + Math.floor(this.playerControl.currentTime % 60)
          let currentMinutes = Math.floor(this.playerControl.currentTime / 60)
          let timeProgress = currentMinutes + ':' + currentSeconds

          let duration
          let Seconds
          let Minutes
          let progress
          if(!isNaN(this.playerControl.duration) && this.playerControl.duration+'' !== 'Infinity') {
            Seconds = (Math.floor(this.playerControl.duration % 60) < 10 ? '0' : '') + Math.floor(this.playerControl.duration % 60)
            Minutes = Math.floor(this.playerControl.duration / 60)
            duration = Minutes + ':' + Seconds
            progress = this.getProgress(this.playerControl.currentTime, this.playerControl.duration)
          } else {
            duration = 'Live'
            progress = 95
          }
          this.updateAudioPlayerTimes({id: 'audio-player-'+this.SubscriptionModuleId, timeProgress: timeProgress, endTime: duration, timeProgressPercent: progress}) 
        } catch(e) {
          console.log('error: ', e)
        }
      },
      getProgress(currentTime, lastTime) {
        let progress
        try{
          progress = (currentTime / lastTime) * 100
        } catch(e) {
          console.log('error: ', e)
        }
        if (isNaN(progress)) {
          progress = 95
        }
        return progress
      },
      streamPlayEnd() {
        this.playerControl.currentTime = 0
        this.iconPlayPushUpdate('pause')
      },
      async playPause() {
        try {
          let _payer = this.AudioPlayers.find(player => player.id === 'audio-player-'+this.SubscriptionModuleId)
          if (!this.AudioPlayerInfo.playerReady) {
            let url = await this.getformattedURL(this.StreamURL)
            this.playerControl.src = url
            // Player.addEventListener('error', this.errorHandale, false)
            this.playerControl.load()
            this.AudioPlayerInfo.playerReady = true
            this.playerControl.addEventListener('timeupdate', this.updateDuration)
            this.playerControl.addEventListener('ended', this.streamPlayEnd)
            this.playerControl.addEventListener('error', this.errorHandale, false)
          }
          if (!Helper.IsNullOrEmpty(this.StreamURL)) {
            if (this.playerControl.paused) {
              this.AudioPlayers.map(p => {
                if(p.id !== 'audio-player-'+this.SubscriptionModuleId) {
                  p.player.pause()
                }
              })
              this.playerControl.play()
              this.iconPlayPushUpdate('play')
            } else {
              this.playerControl.pause()
              this.iconPlayPushUpdate('pause')
            }
          }
        } catch(error) {
          this.errorHandale()
        }
      },
      stop(){
        if (!Helper.IsNullOrEmpty(this.StreamURL) && this.AudioPlayerInfo.playerReady) {
          this.playerControl.currentTime = 0
          this.playerControl.pause()
          this.iconPlayPushUpdate('pause')
        } else {
          this.$f7.dialog.alert('Failed to load because no supported source was found.', this.Header)
        }
      },
      iconPlayPushUpdate(value) {
        this.playPauseControl = document.getElementById('play-pause-'+this.SubscriptionModuleId)
        if(!this.playPauseControl){
          return
        }
        if(value === 'play') {
          this.playPauseControl.classList.remove('play-button')
          this.playPauseControl.classList.add('pause-button')
        } else {
          this.playPauseControl.classList.add('play-button')
          this.playPauseControl.classList.remove('pause-button')
        }
      },
      errorHandale(event) {
        let $this = this
        this.$f7.dialog.alert('Failed to load because no supported source was found.', this.Header, () => {
          $this.$f7.view.main.router.navigate($this.$f7.view.main.router.previousRoute.path)
        })
      }
    }
  }
</script>
<template>
  <f7-page ref="radioPage" :page-content="false" name="radio-view">
    <app-header :header="Header"></app-header>
    <app-tab-menu v-if="MainMenuLayout === 1"></app-tab-menu>
    <!-- <app-side-menu v-if="MainMenuLayout === 2"></app-side-menu> -->
    <app-floating-button
      :ShowLike="true"
      :ShowFavorite="true"
      :ShowShare="true"
      :IsLike="IsLike"
      :IsFavorite="Favorite"
      :onLikeClick="onLikeClick"
      :onFavoriteClick="onFavoriteClick"
      :onShareCLick="onShareCLick"
      v-if="Stream"
      :class="{'bottom-margin' : (IsDevSim && MainMenuLayout === 1)}"
      ></app-floating-button>    
    <div class="backgroundimg"></div>
    <f7-page-content v-if="Stream">
      <!-- <audio class="hide" ref="audioPlayer" width="300" height="32" controls="controls">
        <source :src="StreamURL"/>
      </audio> --> 
      <div class="no-margin full-height track-player">
        <!-- Banner Image: Start -->
        <div class="track-banner-wrap">
          <div class="track-banner">
            <div v-if="Stream.StreamCoverImage" class="cover-background track-img" :style="'background-image: url('+ this.$store.getters.AppConfig.Urls.ContentAssetsBaseUrl +  Stream.StreamCoverImage +');'"></div>
            <div v-else class="track-banner-headphone"></div>
          </div>
        </div>
        <!-- Banner Image: End -->
        <!-- Play Controls: Start -->
        <div class="controls-wrap">
          <div class="track-name marquee" :data-marquee="Stream.StreamCaption"></div>

          <div class="duration">
            <f7-progressbar ref="prb" :progress="progressPercent"></f7-progressbar>
          </div>

          <div class="track-info">
            <span ref="trackduration" id="track-duration" class="track-duration">{{TimeProgress}}</span>
            <span class="track-type">{{EndTime}}</span>
          </div>

          <div class="track-controls" :class="{ 'track-controls-material' : MainMenuLayout ===1 }">
            <div class="play-controls">
              <div class="control play">
                <div :id="'play-pause-'+SubscriptionModuleId" class="play-button" @click="playPause()"></div>
              </div>
            </div>
          </div>
        </div>
        <!-- Play Controls: End -->
      </div>
    </f7-page-content>
  </f7-page>
</template>
<style scoped>
  .bottom-margin {
    margin-bottom: 80px!important;
  }
  .floating-button.stop-button {
    width: 50px;
    height: 50px;
    -webkit-box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.4);
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.4);
    border-radius: 25px;
    color: #fff;
    position: relative;
    -webkit-transition-duration: 300ms;
    transition-duration: 300ms;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    overflow: hidden;
    z-index: 1;
  }
  .stop-button {
    background-repeat: no-repeat!important;
    background-color: transparent!important;
    cursor: pointer;
  }
  .play-controls {
    width: 57%;
    margin:-1em auto;
    display: table;
    height: 100%;
  }
  .play-controls .control {
    display: table-cell;
    vertical-align: middle;
    position: relative;
    height: 100%;
  }
  .forward-button {
    height: 27%;
    width: 100%;
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
  }

  .play-controls .rewind, .play-controls .forward {
    width: 30%;
  }

  .play-controls .play {
    width: 40%;
  }

  .headphone-button {
    width: 70%;
    background-repeat: no-repeat;
    background-image: url('../../css/images/headphone-pulse.svg');
  }

  .play-button {
    height: 57%;
    width: 100%;
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
  }

  .pause-button {
    height: 50%;
    width: 100%;
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
  }

  .rewind-button {
    height: 27%;
    width: 100%;
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
  }

  .no-margin {
    margin: 0 !important;
  }

  .full-height {
    height: 100%;
  }

  .hide {
    display: none;
  }

  .track-controls-material {
    bottom: 60px !important;
  }

  .track-banner {
    text-align: center;
    padding: 15px 25px;
    height: 100%;
  }

  .track-banner-headphone {
    background-repeat: no-repeat;
    text-align: center;
    margin: 0 auto;
    background-position: 50% 50%!important;
    height: 98%;
    background-color: #333;
    background-size: 70%;
  }
  .track-img{
    height:98%;
  }
  .track-banner img {
    width: 85%;
  }

  .track-name {
    font-size: 1.5em;
    margin:1em 0 0.5em 0px;
  }

  .track-info {
    font-size: 1.2em;
  }

  .track-info>span {
    margin-top: 0.3em;
    width: 40px;
  }

  .track-duration {
    float: left;
  }

  .track-type {
    float: right;
  }

  .track-controls {
    width: 100%;
    /*position: fixed;
    left: 0;
    right: 0;
    bottom: 15px;*/
    height: 70%;
  }
  .track-player{
    display: flex;
    flex-direction:column;
    overflow: hidden;
  }
  .track-banner-wrap {
    flex:1;
    height: 60%;
  }
  .controls-wrap{
    flex:2;
    padding: 0 25px;
  }
  .skip-time {
    position: absolute;
    text-align: center;
    width: 100%;
    font-size: .8em;
    top: 69%;
  }

  .marquee {
    overflow: hidden;
    text-align: left;
  }

  .marquee.marquee-speed-drowsy:before {
    animation-duration: 30s;
  }

  .marquee.marquee-speed-slow:before {
    animation-duration: 20s;
  }

  .marquee.marquee-speed-custom:before {
    animation-duration: inherit;
  }

  .marquee.marquee-speed-normal:before {
    animation-duration: 10s;
  }

  .marquee.marquee-speed-fast:before {
    animation-duration: 7s;
  }

  .marquee.marquee-speed-swift:before {
    animation-duration: 5s;
  }

  .marquee.marquee-speed-hyper:before {
    animation-duration: 2s;
  }

  @keyframes movement-smooth {
    from {
      transform: translateX(0%);
      left: 100%;
    }
    to {
      transform: translateX(-100%);
      left: 0%;
    }
  }

  @keyframes movement-steps20 {
    0% {
      transform: translateX(0%);
      left: 100%;
    }
    5%, 9.99% {
      transform: translateX(-5%);
      left: 95%;
    }
    10%, 14.99% {
      transform: translateX(-10%);
      left: 90%;
    }
    15%, 19.99% {
      transform: translateX(-15%);
      left: 85%;
    }
    20%, 24.99% {
      transform: translateX(-20%);
      left: 80%;
    }
    25%, 29.99% {
      transform: translateX(-25%);
      left: 75%;
    }
    30%, 34.99% {
      transform: translateX(-30%);
      left: 70%;
    }
    35%, 39.99% {
      transform: translateX(-35%);
      left: 65%;
    }
    40%, 44.99% {
      transform: translateX(-40%);
      left: 60%;
    }
    45%, 49.99% {
      transform: translateX(-45%);
      left: 55%;
    }
    50%, 54.99% {
      transform: translateX(-50%);
      left: 50%;
    }
    55%, 59.99% {
      transform: translateX(-55%);
      left: 45%;
    }
    60%, 64.99% {
      transform: translateX(-60%);
      left: 40%;
    }
    65%, 69.99% {
      transform: translateX(-65%);
      left: 35%;
    }
    70%, 74.99% {
      transform: translateX(-70%);
      left: 30%;
    }
    75%, 79.99% {
      transform: translateX(-75%);
      left: 25%;
    }
    80%, 84.99% {
      transform: translateX(-80%);
      left: 20%;
    }
    85%, 89.99% {
      transform: translateX(-85%);
      left: 15%;
    }
    90%, 94.99% {
      transform: translateX(-90%);
      left: 10%;
    }
    95%, 99.99% {
      transform: translateX(-95%);
      left: 5%;
    }
    100% {
      transform: translateX(-100%);
      left: 0%;
    }
  }

  @keyframes movement-steps10 {
    0% {
      transform: translateX(0%);
      left: 100%;
    }
    10%, 19.99% {
      transform: translateX(-10%);
      left: 90%;
    }
    20%, 29.99% {
      transform: translateX(-20%);
      left: 80%;
    }
    30%, 39.99% {
      transform: translateX(-30%);
      left: 70%;
    }
    40%, 49.99% {
      transform: translateX(-40%);
      left: 60%;
    }
    50%, 59.99% {
      transform: translateX(-50%);
      left: 50%;
    }
    60%, 69.99% {
      transform: translateX(-60%);
      left: 40%;
    }
    70%, 79.99% {
      transform: translateX(-70%);
      left: 30%;
    }
    80%, 89.99% {
      transform: translateX(-80%);
      left: 20%;
    }
    90%, 99.99% {
      transform: translateX(-90%);
      left: 10%;
    }
    100% {
      transform: translateX(-100%);
      left: 0%;
    }
  }

  @keyframes movement-steps5 {
    0%, 19.99% {
      transform: translateX(0%);
      left: 100%;
    }
    20%, 39.99% {
      transform: translateX(-20%);
      left: 80%;
    }
    40%, 59.99% {
      transform: translateX(-40%);
      left: 60%;
    }
    60%, 79.99% {
      transform: translateX(-60%);
      left: 40%;
    }
    80%, 99.99% {
      transform: translateX(-80%);
      left: 20%;
    }
    100% {
      transform: translateX(-100%);
      left: 0%;
    }
  }

  .marquee.marquee-movement-smooth:before {
    animation-name: movement-smooth;
  }

  .marquee.marquee-movement-steps20:before {
    animation-name: movement-steps20;
  }

  .marquee.marquee-movement-steps10:before {
    animation-name: movement-steps10;
  }

  .marquee.marquee-movement-steps5:before {
    animation-name: movement-steps5;
  }

  .marquee.marquee-direction-left:before, .marquee.marquee-direction-normal:before {
    animation-direction: normal;
  }

  .marquee.marquee-direction-alternate:before {
    animation-direction: alternate;
  }

  .marquee.marquee-direction-right:before, .marquee.marquee-direction-reverse:before {
    animation-direction: reverse;
  }

  .marquee:before {
    content: attr(data-marquee);
    white-space: nowrap;
    position: relative;
    transform: translateX(-50%);
    display: inline-block;
    left: 50%;
    animation: linear infinite;
  }

  .marquee:before {
    animation-duration: 10s;
  }

  .marquee:before {
    animation-name: movement-smooth;
  }

  .marquee:before {
    animation-direction: normal;
  }

  @media (min-width:767px){
    /*.track-img{
      height: 70vh;
    }*/
    .play-controls {
      width: 40%;
    }
    .track-banner-wrap {
      height: 70%;
    }
  }
  @media (max-width:374px) {
    .play-controls {
      width: 55%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/radio-stream/RadioStream.vue